module.exports = __webpack_public_path__ + "img/@contact_bnr1.87dff46c.jpg";